// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animation spinner bouton Actualiser */
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── PRINT LAYOUT ──────────────────────────────────────────────────────────── */
.print-layout {
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 13px;
  color: #222;
  background: #fff;
  padding: 20px 28px;
  width: 100%;
  box-sizing: border-box;
}

.pl-header {
  border-bottom: 3px solid #4a505c;
  padding-bottom: 14px;
  margin-bottom: 20px;
}

.pl-section {
  margin-bottom: 28px;
  page-break-inside: avoid;
}

.pl-section-title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #4a505c;
  background: #f5f4f2;
  border-left: 4px solid #90867d;
  padding: 6px 12px;
  margin-bottom: 12px;
  border-radius: 0 6px 6px 0;
}

/* KPI cards */
.pl-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.pl-kpi-card {
  border: 1px solid #d4c8bc;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
  page-break-inside: avoid;
}

.pl-kpi-card-head {
  font-weight: 700;
  font-size: 0.82rem;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.pl-kpi-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
  font-size: 0.78rem;
}

.pl-kpi-label { color: #777; }
.pl-kpi-val   { font-weight: 600; }

/* Tables */
.pl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.72rem;
  margin-top: 4px;
  border-radius: 6px;
  overflow: hidden;
}

.pl-table thead tr {
  background: #f5f4f2;
}

.pl-table th {
  padding: 7px 10px;
  font-weight: 700;
  color: #4a505c;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 2px solid #d4c8bc;
  white-space: nowrap;
}

.pl-table tbody tr:nth-child(even) { background: #f9f8f7; }
.pl-table tbody tr:nth-child(odd)  { background: #fff; }

.pl-table td {
  padding: 5px 10px;
  border-bottom: 1px solid #ede9e4;
  vertical-align: middle;
}

/* Bloc groupe (par projet) */
.pl-group-block {
  border: 2px solid #d4c8bc;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 24px;
  background: #fff;
  page-break-inside: avoid;
}

.pl-group-title {
  font-size: 1rem;
  font-weight: 800;
  color: #4a505c;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #d4c8bc;
  padding-bottom: 8px;
}

/* Bloc ville */
.pl-ville-block {
  margin-bottom: 32px;
}

.pl-ville-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: #3d4452;
  background: #f0ede8;
  border-left: 5px solid #90867d;
  padding: 8px 16px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  page-break-before: always;
}

.pl-ville-block:first-of-type .pl-ville-title {
  page-break-before: avoid;
}

/* Sous-section titre (dans bloc projet) */
.pl-subsec-title {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
  margin-bottom: 6px;
  padding-left: 2px;
}

/* ── @MEDIA PRINT ─────────────────────────────────────────────────────────── */
@media print {
  body {
    margin: 0;
    padding: 0;
    background: #fff !important;
    print-color-adjust: exact;
  }

  .print-layout button,
  .print-layout [draggable],
  .print-layout .print-no-print {
    display: none !important;
  }

  .pl-section {
    page-break-before: auto;
    page-break-inside: avoid;
  }
  .pl-section-detail {
    page-break-before: always;
    page-break-inside: auto;
  }

  .pl-table tr { page-break-inside: avoid; }
  .pl-table    { page-break-inside: auto; }

  .pl-group-block { page-break-inside: avoid; }

  * {
    print-color-adjust: exact !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Decisionnel.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iFAAiF;AACjF;EACE,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB,WAAW,EAAE;AAC7B,gBAAgB,gBAAgB,EAAE;;AAElC,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,qCAAqC,mBAAmB,EAAE;AAC1D,qCAAqC,gBAAgB,EAAE;;AAEvD;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE;IACE,SAAS;IACT,UAAU;IACV,2BAA2B;IAE3B,yBAAyB;EAC3B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA,eAAe,wBAAwB,EAAE;EACzC,eAAe,uBAAuB,EAAE;;EAExC,kBAAkB,wBAAwB,EAAE;;EAE5C;IAEE,oCAAoC;EACtC;AACF","sourcesContent":["/* Animation spinner bouton Actualiser */\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to   { transform: rotate(360deg); }\r\n}\r\n\r\n/* ── PRINT LAYOUT ──────────────────────────────────────────────────────────── */\r\n.print-layout {\r\n  font-family: 'Segoe UI', Arial, sans-serif;\r\n  font-size: 13px;\r\n  color: #222;\r\n  background: #fff;\r\n  padding: 20px 28px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pl-header {\r\n  border-bottom: 3px solid #4a505c;\r\n  padding-bottom: 14px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pl-section {\r\n  margin-bottom: 28px;\r\n  page-break-inside: avoid;\r\n}\r\n\r\n.pl-section-title {\r\n  font-size: 0.78rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.8px;\r\n  color: #4a505c;\r\n  background: #f5f4f2;\r\n  border-left: 4px solid #90867d;\r\n  padding: 6px 12px;\r\n  margin-bottom: 12px;\r\n  border-radius: 0 6px 6px 0;\r\n}\r\n\r\n/* KPI cards */\r\n.pl-kpi-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n}\r\n\r\n.pl-kpi-card {\r\n  border: 1px solid #d4c8bc;\r\n  border-radius: 8px;\r\n  padding: 12px 14px;\r\n  background: #fff;\r\n  page-break-inside: avoid;\r\n}\r\n\r\n.pl-kpi-card-head {\r\n  font-weight: 700;\r\n  font-size: 0.82rem;\r\n  margin-bottom: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pl-kpi-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 2px 0;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.pl-kpi-label { color: #777; }\r\n.pl-kpi-val   { font-weight: 600; }\r\n\r\n/* Tables */\r\n.pl-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.72rem;\r\n  margin-top: 4px;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pl-table thead tr {\r\n  background: #f5f4f2;\r\n}\r\n\r\n.pl-table th {\r\n  padding: 7px 10px;\r\n  font-weight: 700;\r\n  color: #4a505c;\r\n  font-size: 0.65rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  border-bottom: 2px solid #d4c8bc;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pl-table tbody tr:nth-child(even) { background: #f9f8f7; }\r\n.pl-table tbody tr:nth-child(odd)  { background: #fff; }\r\n\r\n.pl-table td {\r\n  padding: 5px 10px;\r\n  border-bottom: 1px solid #ede9e4;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Bloc groupe (par projet) */\r\n.pl-group-block {\r\n  border: 2px solid #d4c8bc;\r\n  border-radius: 8px;\r\n  padding: 16px 18px;\r\n  margin-bottom: 24px;\r\n  background: #fff;\r\n  page-break-inside: avoid;\r\n}\r\n\r\n.pl-group-title {\r\n  font-size: 1rem;\r\n  font-weight: 800;\r\n  color: #4a505c;\r\n  margin-bottom: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-bottom: 2px solid #d4c8bc;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n/* Bloc ville */\r\n.pl-ville-block {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.pl-ville-title {\r\n  font-size: 1.1rem;\r\n  font-weight: 800;\r\n  color: #3d4452;\r\n  background: #f0ede8;\r\n  border-left: 5px solid #90867d;\r\n  padding: 8px 16px;\r\n  border-radius: 0 8px 8px 0;\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  page-break-before: always;\r\n}\r\n\r\n.pl-ville-block:first-of-type .pl-ville-title {\r\n  page-break-before: avoid;\r\n}\r\n\r\n/* Sous-section titre (dans bloc projet) */\r\n.pl-subsec-title {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  color: #666;\r\n  margin-bottom: 6px;\r\n  padding-left: 2px;\r\n}\r\n\r\n/* ── @MEDIA PRINT ─────────────────────────────────────────────────────────── */\r\n@media print {\r\n  body {\r\n    margin: 0;\r\n    padding: 0;\r\n    background: #fff !important;\r\n    -webkit-print-color-adjust: exact;\r\n    print-color-adjust: exact;\r\n  }\r\n\r\n  .print-layout button,\r\n  .print-layout [draggable],\r\n  .print-layout .print-no-print {\r\n    display: none !important;\r\n  }\r\n\r\n  .pl-section {\r\n    page-break-before: auto;\r\n    page-break-inside: avoid;\r\n  }\r\n  .pl-section-detail {\r\n    page-break-before: always;\r\n    page-break-inside: auto;\r\n  }\r\n\r\n  .pl-table tr { page-break-inside: avoid; }\r\n  .pl-table    { page-break-inside: auto; }\r\n\r\n  .pl-group-block { page-break-inside: avoid; }\r\n\r\n  * {\r\n    -webkit-print-color-adjust: exact !important;\r\n    print-color-adjust: exact !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
